import service from "@/store/services/size-service";

const state = {
  states: [],
};

const mutations = {
};

const actions = {
  size({}, params) {
    return service
      .size(params)
      .then((kit) => {
        return kit;
      })
      .catch((error) => {
        return [];
      });
  },
  updateSizeProduct({ _ }, product) {
    return service.updateSizeProduct(product);
  },
};

const getters = {
  states: (state) => state.states,
};

const size = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default size;
